import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { Profile } from '@graphql/__generated__/graphql';
import dayjs from '@lib/dayjs';
import { Locale } from '@core/constants/locales.constants';
import { filterAppearancesByTeam } from '@utils/playerStats.utils';
import {
  SfaPlayerMatchAppearancesProps,
  SfaPlayerMatchAppearanceRow,
} from '@components/v3/organisms/sfa-player-match-appearances';

type SfaPlayerMatchAppearancesTransformDictionary = {
  title: string;
  goalsLegend: string;
  cardsLegend: string;
  competitionFilterLabel: string;
  competitionFilterAllLabel: string;
};

const sfaPlayerMatchAppearancesTransform = (
  profile: CleanContentful<Profile>,
  context: {
    currentTeamId: string | undefined;
    teamLabel?: string;
    locale: Locale;
  },
  dictionary: SfaPlayerMatchAppearancesTransformDictionary
): SfaPlayerMatchAppearancesProps => {
  const { currentTeamId, teamLabel, locale } = context;

  const teamFiltered = filterAppearancesByTeam(
    profile?.matchAppearances,
    currentTeamId
  );

  const availableCompetitions = Array.from(
    new Set(
      teamFiltered
        .map((entry) => entry.competition?.trim())
        .filter((value): value is string => !!value)
    )
  ).sort((a, b) => a.localeCompare(b));

  const djs = dayjs(locale);

  const appearances: SfaPlayerMatchAppearanceRow[] = teamFiltered.map(
    (entry) => {
      const parsed = djs(entry.date);
      return {
        date: parsed.isValid() ? parsed.format('DD/MM/YYYY') : entry.date,
        match: entry.match,
        competition: entry.competition,
        goals: Array.isArray(entry.goals) ? entry.goals : [],
        yellowCards: entry.cards?.yellow ?? 0,
        redCards: entry.cards?.red ?? 0,
      };
    }
  );

  return {
    title: dictionary.title,
    teamLabel,
    goalsLegend: dictionary.goalsLegend,
    cardsLegend: dictionary.cardsLegend,
    competitionFilterLabel: dictionary.competitionFilterLabel,
    competitionFilterAllLabel: dictionary.competitionFilterAllLabel,
    availableCompetitions,
    appearances,
  };
};

export default sfaPlayerMatchAppearancesTransform;
